import React from 'react'
import {
  formatAmount,
  formatDayOfMonth,
  formatPaymentAccount
} from '../../services/utils'
import {AutoPaySettings, PaymentAccount} from '../../types/app-types'
import LabeledValue from '../common/LabeledValue'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  faCalendarCheck,
  faCalendarXmark,
  faGear,
  faTrashCan
} from '@fortawesome/free-solid-svg-icons'

export interface PaymentAccountListItemProps {
  paymentAccount: PaymentAccount
  isAutoPayAccount: boolean
  autoPaySettings: AutoPaySettings
  onRemovePaymentAccount: (paymentAccount: PaymentAccount) => void
  onEditAutoPay: (paymentAccount: PaymentAccount) => void
  onEnableAutoPay: (paymentAccount: PaymentAccount) => void
  onDisableAutoPay: (paymentAccount: PaymentAccount) => void
}

const PaymentAccountListItem = (props: PaymentAccountListItemProps) => {
  const {
    paymentAccount,
    isAutoPayAccount,
    autoPaySettings,
    onRemovePaymentAccount,
    onEditAutoPay,
    onEnableAutoPay,
    onDisableAutoPay
  } = props

  return (
    <div className="card-default w-full">
      <div className="card-body-default">
        <div className="w-full">
          {isAutoPayAccount ? (
            <span className="indicator-item indicator-start badge badge-secondary text-xs">
              AutoPay Enabled
            </span>
          ) : (
            ''
          )}
        </div>
        <div className="flex w-full items-start mt-4">
          <div className="flex-grow flex flex-col">
            <LabeledValue
              value={`${paymentAccount.adyenPaymentIssuer} ${paymentAccount.adyenPaymentMethod}`}
              label="Payment Method"
            />
            <LabeledValue
              value={formatPaymentAccount(paymentAccount)}
              label="Account"
            />
            <LabeledValue value={paymentAccount.adyenOwner} label="Owner" />
          </div>
          {isAutoPayAccount ? (
            <div className="flex-grow flex flex-col">
              <LabeledValue value="On" label="AutoPay" />
              <LabeledValue
                value={formatAmount(autoPaySettings.autoPayAmount)}
                label="AutoPay Amount"
              />
              <LabeledValue
                value={formatDayOfMonth(autoPaySettings.autoPayDayOfMonth)}
                label="AutoPay Day of Month"
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="card-actions mt-4 gap-4">
          {!isAutoPayAccount ? (
            <a
              onClick={e => onEnableAutoPay(paymentAccount)}
              className="link link-primary text-sm"
            >
              <FontAwesomeIcon
                icon={faCalendarCheck}
                className="text-md mr-1"
              />
              Enable AutoPay
            </a>
          ) : (
            ''
          )}

          {isAutoPayAccount ? (
            <>
              <a
                onClick={e => onEditAutoPay(paymentAccount)}
                className="link link-primary text-sm"
              >
                <FontAwesomeIcon icon={faGear} className="text-md mr-1" />
                Manage AutoPay
              </a>

              <a
                onClick={e => onDisableAutoPay(paymentAccount)}
                className="link link-primary text-sm"
              >
                <FontAwesomeIcon
                  icon={faCalendarXmark}
                  className="text-md mr-1"
                />
                Disable AutoPay
              </a>
            </>
          ) : (
            ''
          )}

          <a
            onClick={e => onRemovePaymentAccount(paymentAccount)}
            className="link link-primary text-sm"
          >
            <FontAwesomeIcon icon={faTrashCan} className="text-md mr-1" />
            Remove Account
          </a>
        </div>
      </div>
    </div>
  )
}

export default PaymentAccountListItem
